var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopapothekeAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#ED0334",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9641 16.2935C48.441 16.3422 42.3591 17.634 35.4549 19.1423C21.2888 22.2489 21.6221 22.1468 20.3133 23.5529C19.2356 24.7279 19.0069 25.3945 19.0069 27.5281C19.0069 29.2018 19.0191 29.2796 19.4156 30.1092C19.9557 31.2478 20.7634 32.0141 22.0722 32.6271C22.9066 33.0237 24.2033 33.3959 28.4996 34.4298C31.4651 35.1451 34.1193 35.836 34.4161 35.9503C35.1727 36.2836 35.8149 36.9088 36.1093 37.5876C36.2504 37.933 36.9437 40.6796 37.6492 43.723C39.0213 49.6395 39.267 50.3694 40.2401 51.469C40.6002 51.8631 41.1013 52.2231 41.7558 52.5394L42.7289 53.0259H44.4634C46.5921 53.0259 47.2854 52.7973 48.4288 51.7487C49.2609 50.9824 49.7109 50.2283 50.1075 48.9997C50.4943 47.7493 55.895 23.2975 55.9704 22.3779C56.106 21.0756 55.7723 19.7678 55.0292 18.6898C54.2862 17.6118 53.1827 16.8345 51.9174 16.4979C50.9687 16.2303 50.105 16.1767 48.9641 16.2935Z",
    fill: "#ED0334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0844 41.6645C19.1991 42.0976 16.888 44.0924 16.1825 46.7636C15.9392 47.7367 15.9392 49.627 16.1825 50.5977C16.9901 53.6532 19.7367 55.6992 23.0477 55.6992C26.4731 55.6846 29.2075 53.5 29.913 50.2011C30.3996 47.9022 29.7841 45.5764 28.2587 43.9246C27.4908 43.0494 26.5019 42.3966 25.3954 42.0343C24.5366 41.7424 22.8556 41.5478 22.0868 41.6645H22.0844Z",
    fill: "#ED0334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopapothekeAppIcon);
export default __webpack_public_path__ + "static/media/shopapotheke-app-icon.a6b315fb56a435873721c01feb5d308d.svg";
export { ForwardRef as ReactComponent };